export default __webpack_public_path__ + "static/media/ali-abderrahmane.b04c4b95.svg";